function isValidJson(value) {
  try {
    JSON.parse(value);
    return true;
  } catch (_unused) {
    return false;
  }
}
export function tryParseJson(value) {
  return typeof value === 'string' && isValidJson(value) ? JSON.parse(value) : value;
}